const emptyState = {
  ing: false,
  articleId: null,
  url: "",
  firstLevelClassId: "",
  secondLevelClassId: "",
  tags: [],
  add_tags: [],
  articleTitle: "",
  content: "",
  html: "",
  source: "",
  createTime: "",
  collectionTime: "",
  collectionProcess: 0,
  fileList: [],
  fileUrl: "",
};

const localArticle = {
  state: {
    ...emptyState,
  },

  mutations: {
    SET_DATA: (state, data) => {
      state.url = data.url;
      state.firstLevelClassId = data.firstLevelClassId;
      state.secondLevelClassId = data.secondLevelClassId;
      state.tags = data.tags;
      state.add_tags = data.add_tags;
      state.articleId = data.articleId;
      state.articleTitle = data.articleTitle;
      state.content = data.content;
      state.html = data.html;
      state.source = data.source;
      state.createTime = data.createTime;
      state.collectionTime = data.collectionTime;
      state.collectionProcess = data.collectionProcess;
      state.fileList = data.fileList;
      state.fileUrl = data.fileUrl;
    },
    SET_Id: (state, articleId) => {
      state.articleId = articleId;
    },
    SET_STATUS: (state, status) => {
      state.ing = status;
    },
    CLEAR_LOCAL_ARTICLE_DATA: (state) => {
      Object.assign(state, emptyState);
    },
  },

  getters: {
    getLocalArticleInfo: (state) => {
      return {
        ing: state.ing,
        url: state.url,
        firstLevelClassId: state.firstLevelClassId,
        secondLevelClassId: state.secondLevelClassId,
        tags: state.tags,
        add_tags: state.add_tags,
        articleId: state.articleId,
        articleTitle: state.articleTitle,
        content: state.content,
        html: state.html,
        source: state.source,
        createTime: state.createTime,
        collectionTime: state.collectionTime,
        collectionProcess: state.collectionProcess,
        fileList: state.fileList,
        fileUrl: state.fileUrl,
      };
    },
    getLocalArticleId: (state) => {
      return {
        articleId: state.articleId,
      };
    },
  },

  actions: {
    recordData2({ commit }, data) {
      console.log(data);
      commit("SET_STATUS", true);
      commit("SET_DATA", data);
    },
    recordId2({ commit }, articleId) {
      commit("SET_Id", articleId);
    },
    clearData2({ commit }) {
      commit("SET_STATUS", false);
      commit("SET_DATA", {
        url: "",
        firstLevelClassId: "",
        secondLevelClassId: "",
        tags: [],
        add_tags: [],
        fileList: [],
        fileUrl: "",
      });
    },
  },
};

export default localArticle;
